import React from "react";
import { Trans } from "react-i18next";
import { Link } from "@material-ui/core";
import { useRouter, Route } from "../common/Router";
import theme from "../../common/theme";
import { pushCustomEvent } from "../../utils/customEventHelper";

type LinkedMessageProps = {
  i18nKey: string;
  to: Route;
  testId: string;
  gtmEvent?: string;
};

const LinkedMessage: React.FC<LinkedMessageProps> = ({
  i18nKey,
  to,
  testId,
  gtmEvent,
}) => {
  const { setLoc } = useRouter();
  return (
    <Trans i18nKey={i18nKey}>
      {""}
      <Link
        data-testid={testId}
        onClick={(): void => {
          if (gtmEvent) {
            pushCustomEvent(gtmEvent);
          }
          setLoc(to);
          window.location.hash = `#${to}`;
        }}
        style={{
          textDecoration: "underline",
          fontWeight: theme.typography.fontWeightBold,
          color: theme.palette.common.black,
          cursor: "pointer",
        }}
      >
        {""}
      </Link>
      {""}
    </Trans>
  );
};

export default LinkedMessage;
